import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { connectorsClient } from '#pplx_generated/typespec/rest/connectors/client.js';
export const CONNECTOR_ID_SUPPORTING_REDIRECT = {
    box: 'box',
    dropbox: 'dropbox',
    gcal: 'gcal',
    google_drive: 'google_drive',
    onedrive: 'onedrive',
    outlook: 'outlook',
    sharepoint: 'sharepoint',
    zoom: 'zoom',
};
export const isConnectorIdSupportingRedirect = (connectorId) => Object.hasOwn(CONNECTOR_ID_SUPPORTING_REDIRECT, connectorId);
export async function getNativeOAuthConnectorRedirectUrl({ name, referrer, referrerId, redirectPath, redirectOrigin, unauthedRedirectPath, autoClose, forceAccountSelection, reason, }) {
    const { data, error, response } = await connectorsClient.GET(`/rest/connectors/${name}/connect`, reason, {
        timeoutMs: getQueryTimeoutMs(),
        numRetries: 1,
        reason,
        params: {
            query: {
                referrer,
                referrer_id: referrerId,
                redirect_path: redirectPath,
                redirect_origin: redirectOrigin,
                unauthed_redirect_path: unauthedRedirectPath,
                auto_close: autoClose,
                force_account_selection: forceAccountSelection,
            },
        },
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to initiate OAuth flow',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data.redirect_url ?? null;
}
//# sourceMappingURL=nativeOAuthConnectors.js.map